<div class="page-container">
    <div class="controls-container">
        <mat-slide-toggle color="primary" (change)="showReadChanged($any($event))">
            {{ 'Notifications.IncludeRead' | translate }}
        </mat-slide-toggle>
        <a routerLink="/notification-settings" mat-icon-button [matTooltip]="'MenuItem.NotificationSettings' | translate">
            <mat-icon>settings</mat-icon>
        </a>
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="notifications">
            <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'General.Date' | translate }}</th>
                <td mat-cell *matCellDef="let item">{{ item.createdDate | localizedDate: 'short' }}</td>
            </ng-container>
            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef>{{ 'Notifications.Title' | translate }}</th>
                <td mat-cell *matCellDef="let item">{{ item.title }}</td>
            </ng-container>
            <ng-container matColumnDef="message">
                <th mat-header-cell *matHeaderCellDef>{{ 'Notifications.Message' | translate }}</th>
                <td mat-cell *matCellDef="let item" class="multiline">{{ item.message.replace('\\n', '\n') }}</td>
            </ng-container>
            <ng-container matColumnDef="confirm">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let item">
                    @if (!item.confirmedDate) {
                        <button mat-icon-button (click)="markAsRead(item)" [matTooltip]="'Notifications.MarkAsRead' | translate">
                            <mat-icon>check</mat-icon>
                        </button>
                    } @else {
                        {{ 'Notifications.ReadOn' | translate }}
                        <br />
                        {{ item.confirmedDate | localizedDate: 'short' }}
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let item">
                    <a
                        mat-icon-button
                        [href]="item.referenceLink"
                        target="_blank"
                        [disabled]="!item.referenceLink"
                        [matTooltip]="'Notifications.GoToReference' | translate"
                        [matTooltipDisabled]="!item.referenceLink">
                        <mat-icon fontSet="material-icons-outlined">outbound_outlined</mat-icon>
                    </a>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ confirmed: !!row.confirmedDate }"></tr>

            <tr *matNoDataRow>
                <td [attr.colSpan]="displayedColumns.length">
                    <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                        {{ 'Notifications.NoNotificationsLastNDays' | translate: { value: numberOfDays } }}
                    </div>
                </td>
            </tr>
        </table>

        @if (isLoading) {
            <div class="loading">
                <mat-spinner [diameter]="48" />
            </div>
        }
    </div>
</div>
